import { employeeApi } from 'Api/employee';
import { Col, Empty, Row } from 'antd';
import { Loader } from 'components/Global';
import Ellipse from 'components/Global/Ellipse';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';

const DeductionsModal: React.FC<any> = ({
	employeeId,
	activeTab,
	isUSD,
	setEarningsAmount,
	isLoading,
	setIsLoading,
}) => {
	const [data, setData] = useState<any[]>([]);

	const { baseCurrencySymbol, usdCurrencySymbol } = useSelector(
		(state: any) => state.userProfile.data
	);

	useEffect(() => {
		if (activeTab === 'deductions') {
			fetchEmployeeDeductions();
		}
	}, [activeTab]);

	const fetchEmployeeDeductions = async () => {
		setIsLoading(true);
		try {
			const apiData = await employeeApi.getEmployeeMasterDeductions({
				employeeId,
			});

			const responseData = apiData?.data?.data || [];
			const isPayrollRun = apiData?.data?.isPayrollRun;

			let finalData = isPayrollRun
				? responseData
				: responseData.filter((item: any) => item.isChecked);

			setData(finalData);
			const total = finalData?.reduce(
				(sum: any, item: any) =>
					sum + parseFloat(item?.amount || '0.00'),
				0
			);
			setEarningsAmount(total);
		} catch (error: any) {
			if (
				error.response?.data?.message !==
				'Setup Napsa Details in statutory components for selected pay period'
			) {
				toastText(error.response?.data?.message, 'error');
			}
		}
		setIsLoading(false);
	};

	return (
		<>
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<div className={styles.deductionsContainer}>
					{/* If no data, show "No Data" message */}
					{data.length === 0 ? (
						<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
					) : (
						<Row gutter={16}>
							{data.map((item: any) => (
								<Col
									key={item.id || item.description}
									span={12}
									className={styles.deductionsItem}
								>
									<div className={styles.deductionsContent}>
										<div className={styles.labelContainer}>
											<Ellipse
												maxLength={20}
												message={item?.description?.toUpperCase()}
												isTooltip={true}
												tooltipMessage={item?.description?.toUpperCase()}
												key={item?.description?.toUpperCase()}
											/>
										</div>
										<span className={styles.colon}>:</span>
										{/* :{' '} */}
										<div className={styles.amount}>
											{item.amount}{' '}
											{isUSD
												? usdCurrencySymbol
												: baseCurrencySymbol}
										</div>
									</div>
								</Col>
							))}
						</Row>
					)}
				</div>
			)}
		</>
	);
};

export default DeductionsModal;
